import { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import './KakaoCallbackPage.css';

function KakaoCallbackPage() {
  const [searchParams] = useSearchParams();
  const setTokens = useAuthStore((state) => state.setTokens);
  const rememberMePref = useAuthStore((state) => state.rememberMe);
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const socialSub = searchParams.get('socialSub');
    const sessionExpiresAtRaw = searchParams.get('sessionExpiresAt');
    const rememberRaw = searchParams.get('rememberMe');
    const sessionExpiresAt = sessionExpiresAtRaw ? Number(sessionExpiresAtRaw) : null;
    const rememberMe =
      rememberRaw == null ? rememberMePref : rememberRaw === 'true' || rememberRaw === '1';

    if (!accessToken || !socialSub) {
      setStatus('error');
      setErrorMessage('로그인 정보가 올바르지 않습니다. 다시 시도해 주세요.');
      return;
    }

    setTokens({
      accessToken,
      socialSub,
      rememberMe,
      sessionExpiresAt:
        sessionExpiresAt != null && !Number.isNaN(sessionExpiresAt) ? sessionExpiresAt : null,
    });
    setStatus('success');
  }, [searchParams, setTokens, rememberMePref]);

  if (status === 'success') {
    return <Navigate to="/setup-profile" replace />;
  }

  return (
    <div className="callback-page">
      {status === 'loading' && <p>로그인 처리 중...</p>}
      {status === 'error' && (
        <div className="callback-page__error">
          <p>{errorMessage}</p>
          <a href="/login">로그인 화면으로</a>
        </div>
      )}
    </div>
  );
}

export default KakaoCallbackPage;
